import cn from 'classnames';
import type { FieldRenderProps } from '../Input/Input';
import { FormError } from '@creditflowresearch/uilib/Form/FormError';
import Checkbox from './Checkbox';
import styles from './checkbox.module.scss';
import isDefined from '../utils/isDefined';

export interface ICheckboxInputProps extends Partial<FieldRenderProps<any, HTMLInputElement>> {
  className?: string,
  input?: any,
  meta?: any,
  isErrorMessage?: boolean,
  disabled?: boolean,
  id?: string,
  name?: string,
  dataTest?: string,
  checked?: boolean,
}

const CheckboxInput = (props: ICheckboxInputProps) => {
  const {
    className,
    input,
    meta,
    isErrorMessage = true,
    disabled,
  } = props;

  const isError = !!(meta && meta.touched && meta.error);

  return (
    <>
      <Checkbox
        { ...props }
        { ...input }
        className={ cn([{ [styles.isError]: isErrorMessage && isError }, className]) }
        id={ props.id || input.name }
        checked={ isDefined(input.checked) ? !!input.checked : !!input.value }
        disabled={ disabled }
      />
      { isErrorMessage && !input['aria-expanded'] && <FormError { ...props.meta } /> }
    </>
  );
};

export default CheckboxInput;
